/**
 * Shared film-grain texture. A tiny inline-SVG fractal-noise tile used as a
 * repeating background-image. Referenced by the global body overlay
 * (globals.css keeps its own copy of the literal — plain CSS cannot import TS)
 * and by client components that layer grain inside their own stacking context.
 */

export const GRAIN_TEXTURE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";
